<img
	class="client-logo"
	src="{{ clientLogoUrl }}"
	alt="{{ altText }}"
	title="Client Logo"
	data-cy="client-logo"
/>
